// extracted by mini-css-extract-plugin
module.exports = {"root":"Backdrop_root__2J4h7","root-active":"Backdrop_root-active__3cxVk"};